import { useCallback } from 'react';
import { useGetCatalogQuery } from '@platform/state/api';

/** Позиція типу запису серед модулів простору (каталог: `order` = ws.modules прототипу); невідомий тип — у кінці. */
export function useRecordTypeOrder(ws: string): (rtKey: string) => number {
  const { data } = useGetCatalogQuery({ workspaceId: ws });
  return useCallback((rtKey: string) => {
    for (const m of data?.modules ?? []) {
      const rt = m.recordTypes.find((r) => r.key === rtKey) as { order?: number | null } | undefined;
      if (rt) return typeof rt.order === 'number' ? rt.order : Number.MAX_SAFE_INTEGER;
    }
    return Number.MAX_SAFE_INTEGER;
  }, [data]);
}
